export default __webpack_public_path__ + "static/media/stake-more-zenusdc.691bb9ce.svg";